/* eslint-disable react/prop-types */ // TODO: add props
import cx from 'classnames';
import PT from 'prop-types';
import DocumentTitle from 'react-document-title';
import LegacyBreadcrumbs from '../LegacyBreadcrumbs';
import BodyClassName from 'react-body-classname';
import ProfileNav from '../ProfileNav';
import EdroloLogo from '../EdroloLogo';
import SidebarLayout from './SidebarLayout';
import { BypassBlock } from 'edrolo-ui';
import { Breadcrumbs, Crumb } from '../Breadcrumbs';
import { Container } from 'edrolo-style-guide';
import style from './AppContainer.scss';
import { Footer } from 'edrolo/domains/coursePortal/components';

const TopBar = ({ children }) => {
  return (
    <header id="global">
      <div className="container group">{children}</div>
    </header>
  );
};

const WideTopBar = ({ children }) => {
  return (
    <header id="global" className={cx('group', style.wideTopBar)}>
      {children}
    </header>
  );
};

const FullTopBar = ({ children }) => {
  return (
    <header
      id="global"
      className={cx('group', style.fullTopBar)}
      data-test="full-top-bar"
    >
      <Container wide>{children}</Container>
    </header>
  );
};

const LegacyTopBar = ({ breadcrumbs }) => (
  <TopBar>
    <EdroloLogo />
    <LegacyBreadcrumbs breadcrumbs={breadcrumbs} />
    <ProfileNav />
  </TopBar>
);

const ContainerLayout = ({ children }) => (
  <div id="main-content" className="container">
    {children}
  </div>
);

const BlankLayout = ({ children }) => <div id="main-content">{children} </div>;

const AppContainer = ({
  documentTitle = 'Edrolo',
  bodyClassName,
  breadcrumbs, // DEPRECATED, use renderTopBar
  children,
  className,
  wide = false,
  renderLayout,
  renderTopBar = (bc) => <LegacyTopBar breadcrumbs={bc} />,
}) => {
  // set the default layout renderer
  if (!renderLayout) {
    // set a different renderer if wide is set.
    renderLayout = wide
      ? (content) => <BlankLayout>{content}</BlankLayout>
      : (content) => <ContainerLayout>{content}</ContainerLayout>;
  }

  let app = (
    <div className={cx(className || style.container, { [style.wide]: wide })}>
      <div>
        <BypassBlock />
        {renderTopBar && renderTopBar(breadcrumbs)}
        {renderLayout(children)}
      </div>
      <div>
        <Footer />
      </div>
    </div>
  );

  if (documentTitle) {
    app = <DocumentTitle title={documentTitle}>{app}</DocumentTitle>;
  }

  if (bodyClassName) {
    app = <BodyClassName className={bodyClassName}>{app}</BodyClassName>;
  }

  return app;
};

AppContainer.defaultProps = {
  documentTitle: 'Edrolo',
};

const AppContainerWithSidebar = ({
  children,
  sidebarClassName,
  renderSidebar,
  renderTopBar,
  trackingOrigin,
  ...restProps
}) => (
  <AppContainer
    renderLayout={(content) => {
      return (
        <SidebarLayout
          renderSidebar={renderSidebar}
          sidebarClassName={sidebarClassName}
          trackingOrigin={trackingOrigin}
        >
          {content}
        </SidebarLayout>
      );
    }}
    renderTopBar={renderTopBar || null}
    {...restProps}
  >
    <div id="main-content">{children}</div>
  </AppContainer>
);

AppContainer.propTypes = {
  bodyClassName: PT.string,
  breadcrumbs: PT.arrayOf(
    PT.shape({
      label: PT.string,
      url: PT.string,
      anchor: PT.bool,
    })
  ),
  className: PT.string,
  wide: PT.bool,
  renderLayout: PT.func,
};

AppContainer.TopBar = TopBar;
AppContainer.WideTopBar = WideTopBar;
AppContainer.FullTopBar = FullTopBar;
AppContainer.WithSidebar = AppContainerWithSidebar;
AppContainer.ProfileNav = ProfileNav;
AppContainer.LegacyBreadcrumbs = LegacyBreadcrumbs;
AppContainer.EdroloLogo = EdroloLogo;
AppContainer.SidebarLayout = SidebarLayout;
AppContainer.ContainerLayout = ContainerLayout;
AppContainer.BlankLayout = BlankLayout;
AppContainer.Breadcrumbs = Breadcrumbs;
AppContainer.Crumb = Crumb;

export default AppContainer;

AppContainer.propTypes = {
  documentTitle: PT.string,
  bodyClassName: PT.string,
  breadcrumbs: PT.arrayOf(
    PT.shape({
      label: PT.string,
      url: PT.string,
      anchor: PT.bool,
    })
  ),
  className: PT.string,
  wide: PT.bool,
  renderLayout: PT.func,
  renderTopBar: PT.func,
  children: PT.node,
};
